import { Snackbar } from '@yuno/design-system-web'
import { createContext, useContext } from 'react'
import {
  OpenSnackbar,
  SnackbarPosition,
  useSnackbar,
} from '../hooks/snackbar/snackbar.hook'

interface Props {
  message: string
  onCloseSnackbar: () => void
  onOpenSnackbar: OpenSnackbar
  position: SnackbarPosition
  snackOpen: boolean
  width: string
}

const SnackbarContext = createContext<Props>({
  message: null,
  onCloseSnackbar: null,
  onOpenSnackbar: null,
  position: null,
  snackOpen: false,
  width: null,
})

export const SnackbarProvider = ({ children }) => {
  const {
    message,
    onCloseSnackbar,
    onOpenSnackbar,
    position,
    snackOpen,
    type,
    icon,
    width,
  } = useSnackbar()

  return (
    <SnackbarContext.Provider
      value={{
        message,
        onCloseSnackbar,
        onOpenSnackbar,
        position,
        snackOpen,
        width,
      }}
    >
      <Snackbar
        icon={icon}
        message={message}
        severity={type}
        onClose={onCloseSnackbar}
        open={snackOpen}
        anchorOrigin={position}
        width={width}
      />
      {children}
    </SnackbarContext.Provider>
  )
}
export const useSnackbarContext = () => useContext(SnackbarContext)
